import sanitizeHtml from 'sanitize-html';

interface SanitizeOptions {
  allowedTags: string[];
  allowedAttributes: any;
  allowedIframeHostnames: string[];
}

const defaultOptions: SanitizeOptions = {
  allowedTags: [ 'b', 'i', 'em', 'strong', 'a', 'p', 'ul', 'li', 'img', 'h1', 'h2', 'h3' ],
  allowedAttributes: {
    'a': [ 'href' ],
    'img': [ 'src', 'width', 'class' ]
  },
  allowedIframeHostnames: ['www.youtube.com']
};

const sanitize = (dirty: string, options: any) => ({
  __html: sanitizeHtml(
    dirty, 
    { ...defaultOptions, ...options }
  )
});

interface ISanitizeHTML {
  html: string;
  options?: any;
}

export const SanitizeHTML = ({ html, options }: ISanitizeHTML) => (
  <div dangerouslySetInnerHTML={sanitize(html, options)} />
);